import { React, useState } from "react";
import PropTypes from "prop-types";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import Icon, { IconTypes } from "../../../../common/Icon";
import urls from "../../../../../config/urls";

function CourseLandingPageFAQ({ faqs }) {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  }

  return (
    <div className="CourseLandingPage-faq container">
      <div className="container-content">
        <div className="container-heading">
          <h2>
            Frequently <em><span className="lowercase">asked </span></em>Questions
          </h2>
        </div>
        <div className="faq-container">
          {
            faqs?.map((faq, index) => {
              return (
                <Accordion
                  key={`course-landing-page-faq-${index}`}
                  disableGutters
                    elevation={0}
                    sx={{
                      border: "none",
                      "&::before": {
                        display: "none",
                      }
                    }}
                  expanded={expanded === `panel-${index}`} onChange={handleChange(`panel-${index}`)}
                >
                  <AccordionSummary
                    className="faq-question"
                    expandIcon={<Icon type={IconTypes.ArrowDown} />}
                    sx={{
                      alignItems: "flex-start",
                      ".MuiAccordionSummary-expandIconWrapper": {
                        marginTop: "8px",
                      }
                    }}
                  >
                    Q: {faq.question}
                  </AccordionSummary>
                  <AccordionDetails className="faq-answer">
                    <div className="faq-answer-label">A:</div>
                    <div className="faq-answer-content" dangerouslySetInnerHTML={{ __html: faq.answer }} />
                  </AccordionDetails>
                </Accordion>
              )
            })
          }
        </div>
        <div className="links-container">
          <div className="more-info">To find more courses and in-depth educational content in the Catholic Faith, visit our website:</div>
          <a href={urls.root} className="link-home">www.InstituteofCatholicCulture.org</a>
          <div className="social-icons">
            <a href={urls.socialFacebookICC} target="_blank" rel="noopener noreferrer">
              <Icon type={IconTypes.ShareFacebook} inline={true} />
            </a>
            <a href={urls.socialInstagramICC} target="_blank" rel="noopener noreferrer">
              <Icon type={IconTypes.ShareInstagram} inline={true} />
            </a>
            <a href={urls.socialTwitterICC} target="_blank" rel="noopener noreferrer">
              <Icon type={IconTypes.ShareX} inline={true} />
            </a>
            <a href={urls.socialYouTubeICC} target="_blank" rel="noopener noreferrer">
              <Icon type={IconTypes.ShareYouTube} inline={true} />
            </a>
          </div>
          <div className="copyright-container">
            <div className="copyright">© Institute of Catholic Culture</div>
          </div>
        </div>
      </div>
    </div>
  )
}

CourseLandingPageFAQ.propTypes = {
  faqs: PropTypes.array,
};

export default CourseLandingPageFAQ;